import React from 'react';

/**
 * Marca d'água diagonal em cima de fotos/vídeos.
 * - Se logoUrl fornecido, tila o logo do fotógrafo em diagonal.
 * - Caso contrário, mostra o texto padrão "AXSELL".
 */
export default function WatermarkOverlay({ logoUrl, dense = false, watermarkSize = 25, watermarkOpacity = 50, watermarkPosition = 'center' }) {
  const size = `${Math.max(5, Math.min(100, Number(watermarkSize) || 25)) * 8}px`;
  const opacity = Math.max(0, Math.min(100, Number(watermarkOpacity ?? 50))) / 100;
  if (logoUrl) {
    return (
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url(${logoUrl})`,
          backgroundRepeat: 'repeat',
          backgroundSize: size,
          backgroundPosition: watermarkPosition,
          opacity,
          transform: 'rotate(-24deg) scale(1.5)',
          transformOrigin: 'center',
          mixBlendMode: 'normal',
        }}
      />
    );
  }
  return <div className={`watermark-overlay pointer-events-none ${dense ? 'watermark-dense' : ''}`} />;
}
